import {FC, ReactElement, useState} from 'react'
import {names} from 'shared/lib'
import {AdvantageItem} from 'shared/ui/advantageItem'
import {Diamond, Headset, Heart, HistoryCleaning, Incognito, MessageImage, Messages, Upload} from 'shared/ui/icons'
import styles from './styles.module.scss'

const advantageItems: {icon: ReactElement, title: string, description: string, isNew?: boolean}[] = [
  {
    icon: <MessageImage />,
    title: 'Live chatting',
    description: 'Send photos, videos, and gifts in chats.'
  },
  {
    icon: <Diamond />,
    title: 'Get x5 more likes',
    description: 'This will help you find the best connection'
  },
  {
    icon: <Upload />,
    title: 'Profile search promotion',
    description:
      'Your profile will appear higher than those with the free package.'
  },
  {
    icon: <Headset />,
    title: 'Premium support',
    description: 'Get instant answers and help 24/7'
  },
  {
    icon: <Messages />,
    title: 'Top in Messenger',
    description: 'Appear at the top of conversations.'
  },
  {
    icon: <Heart />,
    title: 'Get x3 super matches',
    description:
      'Our system will select for you profiles with the highest possible similarity.'
  },
  {
    icon: <Incognito />,
    title: 'Browse Incognito',
    description: `You'll be able to browse profiles you're interested in and they won't know it.`,
    isNew: true
  },
  {
    icon: <HistoryCleaning />,
    title: 'Auto History Cleaning',
    description: 'We will automatically delete old messages'
  }
]

export const Advantages: FC<{displayItemsCount?: number, className?: string}> = ({displayItemsCount, className}) => {
  const [showAll, setShowAll] = useState(false)
  const [hiddenItemsCount, setHiddenItemsCount] = useState(
    advantageItems.length - (displayItemsCount || 0)
  )

  const handleShowAll = () => {
    setShowAll(true)
  }

  return (
    <div className={styles.advantagesContainer}>
      <div className={names(styles.advantages, className)}>
        {showAll
          ? advantageItems.map((item, index) => <AdvantageItem key={index} {...item} />)
          : advantageItems
            .slice(0, displayItemsCount)
            .map((item, index) => <AdvantageItem key={index} {...item} />)}
      </div>
      {!showAll && displayItemsCount ?
        <span onClick={handleShowAll} className={styles.btnShow}>
          +{hiddenItemsCount} show
        </span>
        : null}
    </div>
  )
}
